import React, { useState, useEffect } from "react";
import { AccountsManagerSvg } from "../../../assets/images";
import {
  CommonHeader,
  EmptyListPage,
  Loader,
  ErrorSuccessModal,
  ConfirmationModal,
} from "../../../components/commons";
import AddAccountModal from "../../../components/ClientSettings/AccountsManager/AddAccountModal";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  addLedgerAction,
  changeCustomerSupplierStatusAction,
  getAllLedgersListAction,
  getAutoUniqueNumberGenerationAction,
  resetAllLedgersList,
  resetAllLedgersListTotal,
  resetAutoUniqueNumberGenerationData,
  resetClientSettingsError,
  resetClientSettingsSuccess,
  resetLedgerMessage,
  resetMessage,
  resetSingleTypeLedgersList,
  updateLedgerAction,
} from "../../../redux/clientSettings";
import {
  AddLedgerPayloadType,
  ChangeStatusCustomerSupplierPayloadType,
  GetAllLedgersListPayloadType,
  GetAutoUniqueNumberPayloadType,
  UpdateLedgerPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import toast, { Toaster } from "react-hot-toast";
import { resetSession } from "../../../redux/auth";
import { AllLedgersListType } from "../../../redux/clientSettings/clientSettingTypes";
import AcccountsManagerTable from "../../../components/ClientSettings/AccountsManager/AccountsManagerTable/AccountsManagerTable";
import { ACCOUNTS_MANAGER_HEADERS } from "../../../constant/tableHeadersConstants/clientSettingsconstants/accountsManagerHeader";
import { SearchIcon } from "../../../components/Icon";
import { PAGINATION_INITIAL } from "../../../constant/invoiceListConst";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type FinalAccountDetailsType = {
  accountName?: string;
  accountNumber?: string;
  ledger_type?: string;
  parent_id?: number;
  to_show?: number;
  cog_type?: number
};

type AppProps = {
  history?: any;
  token: string | null;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  fetching: boolean;
  message:string|null;
  allLedgersList: AllLedgersListType[] | [];
  allLedgersListTotal: string | number;
  dispatchResetLedgerMessage: () => void;
  dispatchAddLedgerAction: (data: AddLedgerPayloadType) => void;
  dispatchUpdateLedgerAction: (data: UpdateLedgerPayloadType) => void;
  dispatchResetClientSettingsSuccess: () => void;
  dispatchResetClientSettingsError: () => void;
  dispatchResetSession: () => void;
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) => void;
  dispatchResetAllLedgersList: () => void;
  dispatchResetSingleTypeLedgersList: () => void;
  dispatchResetAllLedgersListTotal: () => void;
  dispatchResetMessage:()=>void;
  dispatchChangeCustomerSupplierStatusAction:(data:ChangeStatusCustomerSupplierPayloadType)=>void;
  dispatchGetAutoUniqueNumberCheckAction: (data: GetAutoUniqueNumberPayloadType) => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetAutoUniqueNumberGenerationData: () => void;
};

const AccountsManager = ({
  history,
  token,
  success,
  error,
  statusCode,
  fetching,
  allLedgersList,
  allLedgersListTotal,
  message,
  dispatchGetAllLedgersListAction,
  dispatchResetSingleTypeLedgersList,
  dispatchUpdateLedgerAction,
  dispatchResetLedgerMessage,
  dispatchResetClientSettingsError,
  dispatchResetClientSettingsSuccess,
  dispatchResetAllLedgersList,
  dispatchAddLedgerAction,
  dispatchResetSession,
  dispatchResetAllLedgersListTotal,
  dispatchChangeCustomerSupplierStatusAction,
  dispatchResetMessage,
  dispatchGetAutoUniqueNumberCheckAction,
  autoUniqueNumberGenerationData,
  dispatchResetAutoUniqueNumberGenerationData,
}: AppProps) => {
  const [showAddAccountModal, setShowAddAccountModal] =
    useState<boolean>(false);
  const [editAccountDetailsData, setEditAccountDetailsData] = useState<any>({});
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [searchData, setSearchData] = useState("");
  const company_name = history?.location?.state?.company_name;
  const client_code = history?.location?.state?.client_code;
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [searchClear, setSearchClear] = useState(false);
  const [data, setData] = useState<any>([]);
  const [autoUniqueNumberCheck, setAutoUniqueNumberCheck] = useState<boolean>(false);
  const [confirmationModalData, setConfirmationModalData] = useState({
    legal_name: "",
    is_disabled: null,
      ledger_id: "",
      ledger_number:""
      
    });
    const [showConfirmationModal, setShowConfirmationModal] =
    useState<boolean>(false);
  //====================User Management=============================
  const [isAddAccountPresent, setIsAddAccountPresent] = useMenuCheck()
  const [isEditAccountPresent, setIsEditAccountPresent] = useMenuCheck()
  const [isChangeStatusCustomerSupplierPresent, setIsChangeStatusCustomerSupplierPresent] = useMenuCheck()

  //=================================================================

  useEffect(() => {
    dispatchResetAllLedgersList();
    dispatchResetSingleTypeLedgersList();
    dispatchResetClientSettingsError();
    dispatchResetClientSettingsSuccess();
    dispatchResetLedgerMessage();
    dispatchResetAllLedgersListTotal();
    dispatchResetMessage()
    setEditAccountDetailsData({});
    dispatchResetAutoUniqueNumberGenerationData();
    setIsAddAccountPresent("Add Account", "menu")
    setIsEditAccountPresent("Edit Account", "menu")
    setIsChangeStatusCustomerSupplierPresent("Disable Ledgers", "menu")


    const { location: { search = "" } = {} } = window;
  

    if (search) {
       new URLSearchParams(search);
    }
 //eslint-disable-next-line
  }, []);

useEffect(()=>{
  if (success === 1 && message!=null && ( (message?.includes("has been disabled successfully!") || message?.includes("has been enabled successfully!" )))) {
    dispatchResetAllLedgersList();
    dispatchResetClientSettingsError();
    dispatchResetMessage();
    toast.success(`Account manager ${confirmationModalData?.is_disabled===0?"disable":"enable"} successfully!`, {
      duration: 2000,
    });
  
    if (token && client_code) {
      let finalData = {
        offset: 0,
        limit: 20,
        token,
        client_code,
        search_term: searchData,
      };
      if (offset === 0) {

        dispatchGetAllLedgersListAction(finalData);
      }
      else{
        setOffset(0)
      }
    }
  }
 //eslint-disable-next-line
},[message])
  const fetchNewData = (offset: number, limit: number, search?: string) => {
    if (token && client_code) {
      setSearchClear(true)
      let finalData = {
        token,
        client_code,
        search_term: search,
        offset,
        limit,
      };
      if (offset === 0) {
        setOffset(0)
        dispatchGetAllLedgersListAction(finalData);
      }
      else {
        setOffset(0);
      }
    }
  };


  useEffect(() => {
    if (allLedgersList?.length === 0) {
      setData(allLedgersList)
    }
    if (offset > 0) {

      setData((prv: any) => [...prv, ...allLedgersList])
    }
    else {
      setData(allLedgersList)
    }
    //eslint-disable-next-line
  }, [allLedgersList]);

  useEffect(() => {
    if (searchClear) {
      let finalData = {
        token,
        search_term: searchData,
        client_code,
        limit,
        offset,
      }
      if (searchData?.length === 0) {
        dispatchResetAllLedgersList()
        dispatchGetAllLedgersListAction(finalData);
        setOffset(0)
      }

    }
     //eslint-disable-next-line
  }, [searchClear, searchData]);


  useEffect(() => {

    if (token && client_code) {
      let finalData = {
        token,
        client_code,
        search_term: searchData,
        offset,
        limit,
      };

      if (offset < +allLedgersListTotal) {
        dispatchGetAllLedgersListAction(finalData);
      }
      else if (offset === 0 && allLedgersListTotal === '') {
        dispatchGetAllLedgersListAction(finalData);
      }
    }
     //eslint-disable-next-line
  }, [offset])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchData) {
        fetchNewData(0, 10, searchData);
        // setPagination(PAGINATION_INITIAL);
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
     //eslint-disable-next-line
  }, [searchData]);

  const onScroll = () => {
    const scrollTop = document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;

    if (Math.ceil(75 / 100 * scrollHeight) <= scrollTop + clientHeight) {
      if (allLedgersList?.length > 0) {
        setOffset(offset + limit)
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
     //eslint-disable-next-line
  }, [allLedgersList])

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchData(value);
  };
  const toggleAddAccountModal = () => {
    if(token) {
      let finalData = {
        token,
        clientCode: client_code,
        general_settings_type: "ledger_number",
      };
      dispatchGetAutoUniqueNumberCheckAction(finalData);
    }
    setSearchData("")
    setShowAddAccountModal(!showAddAccountModal);
  };

  useEffect(() => {
    if(autoUniqueNumberGenerationData && Object.keys(autoUniqueNumberGenerationData)?.length > 0){
      setAutoUniqueNumberCheck(autoUniqueNumberGenerationData?.is_enable === 1);
    } else {
      setAutoUniqueNumberCheck(false);
    }
  }, [autoUniqueNumberGenerationData])

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "update_account":
        return setSuccessMessage("Account Details Updated Successfully!");
      case "create_account":
        return setSuccessMessage("Account Details Added Successfully!");
      default:
        return setSuccessMessage("Document Created Successfully!");
    }
  };

  const handleResetEditData = () => {
    setIsEdit(false);
    setEditAccountDetailsData({});
  };

  const handleAddAccountDetails = (data: FinalAccountDetailsType) => {
    if (client_code && token) {
      let finalData = {
        client_code,
        ledger_type: data?.ledger_type,
        ledger_name: data?.accountName,
        ledger_number: data?.accountNumber,
        parent_id: data?.parent_id,
        to_show: data?.to_show,
        token,
        cog_type: data?.cog_type
      };

      dispatchAddLedgerAction(finalData);
      setShowAddAccountModal(false);
      handleSuccessMessage("create_account");
    }
  };

  const handleEditAccountDetails = (data: any) => {
    setShowAddAccountModal(false);
    let finalData = {
      token,
      client_code,
      ledger_id: data?.ledger_id,
      ledger_type: data?.ledger_type,
      ledger_name: data?.accountName,
      ledger_number: data?.accountNumber,
      parent_id: data?.parent_id,
      to_show: data?.to_show,
      cog_type: data?.cog_type,
      is_tree: data?.is_tree
    };

    if (token && client_code) {
      setIsEdit(false);
      dispatchUpdateLedgerAction(finalData);
      handleSuccessMessage("update_account");
    }
  };

  const handleSendAccountDetailsToModal = (data: AllLedgersListType) => {
    setIsEdit(true);
    setEditAccountDetailsData(data);
    setShowAddAccountModal(true);
  };

  const handleEnableDisableStatus  =(data:any)=>{
    setShowConfirmationModal(true);
    setConfirmationModalData({ ...data });
  }
  const handleConfirmationModal = () => {
    setShowConfirmationModal(!showConfirmationModal);
  };


  const handleChangeCustomerSupplierStatus = (currentData: any) => {
    if (token && confirmationModalData?.ledger_id){

      let updateData = {
        token,
        client_code:client_code,
        ledger_id: confirmationModalData?.ledger_id,
        is_disabled: confirmationModalData?.is_disabled === 0?1:0,
      };
      dispatchChangeCustomerSupplierStatusAction(updateData);
    }
  };

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    }
    else {
      window.scrollTo(0, 0);
      setOffset(0)
    }
     //eslint-disable-next-line
  }, [success])

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetClientSettingsError();
            }}
          />
        );
      }
    }
   if (success === 1 && message!=null && ( (message?.includes("has been disabled successfully!") || message?.includes("has been enabled successfully!" )))) {
      // FUTURE USE
      // dispatchResetAllLedgersList();
      // dispatchResetClientSettingsError();
      // dispatchResetMessage();
      // toast.success(`Account manager ${confirmationModalData?.is_disabled===0?"disable":"enable"} successfully!`, {
      //   duration: 2000,
      // });
    
      // if (token && client_code) {
      //   let finalData = {
      //     offset: 0,
      //     limit: 20,
      //     token,
      //     client_code,
      //     search_term: searchData,
      //   };
      //   if (offset === 0) {

      //     dispatchGetAllLedgersListAction(finalData);
      //   }
      //   else{
      //     setOffset(0)
      //   }
      // }
    }
    else if (success ===1 && message!=null ){
      dispatchResetClientSettingsSuccess();
      dispatchResetMessage()
      toast.success(successMessage, {
        duration: 2000,
      });
      
      if (token && client_code) {
        let finalData = {
          offset: 0,
          limit: 20,
          token,
          client_code,
          search_term: searchData,
        };
        if (offset === 0) {
          
          dispatchGetAllLedgersListAction(finalData);
        }
      }
    }

    return false;
  };

  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader
          title={`Accounts Manager`}
          company_name={company_name}
          client_code={client_code}
        />
      </div>
      <div className="col-md-6 text-right">
        {!!allLedgersList?.length && isAddAccountPresent && (
          <button onClick={toggleAddAccountModal} className="btn btn-primary">
            + Add Account
          </button>
        )}
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Accounts Manager List</div>
              {!fetching && <div className="sub-heading" style={{ marginTop: "-22px" }}>{`Total ${allLedgersListTotal ? allLedgersListTotal : 0
                } entries found`}</div>}
            </div>
          
            <div className="right-header ">
              <div className="col-md-8" style={{ marginLeft: "70px" }}>
                <span style={{ position: "absolute", top: "8px", left: "25px" }}>
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search Accounts Manager"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchData}
                />
              </div>
            </div>
          </div>

          {allLedgersList?.length ? (
            <AcccountsManagerTable
              offset={offset}
              data={data}
              fetching={fetching}
              headers={isChangeStatusCustomerSupplierPresent?ACCOUNTS_MANAGER_HEADERS:ACCOUNTS_MANAGER_HEADERS?.filter((e)=>e?.value!="status")}
              handleEditAccountDetails={handleSendAccountDetailsToModal}
              isEditAccountPresent={isEditAccountPresent}
              handleEnableDisableStatus={handleEnableDisableStatus}
              isChangeStatusCustomerSupplierPresent={isChangeStatusCustomerSupplierPresent}

            />
          ) : (
            !fetching ? <EmptyListPage
              title="No Accounts Found!"
              text="Add your accounts and manage the list here"
              buttonTitle="+ Add Account"
              showAddButton
              onButtonClick={toggleAddAccountModal}
              company_name={company_name}
              client_code={client_code}
              image={AccountsManagerSvg}
              imageWidth="30%"
            /> : ""
          )}
        </div>
      </div>
      {showAddAccountModal && (
        <AddAccountModal
          isOpen={showAddAccountModal}
          toggleAddFolderModal={toggleAddAccountModal}
          handleAddAccountDetails={handleAddAccountDetails}
          client_code={client_code}
          isEdit={isEdit}
          editAccountDetailsData={editAccountDetailsData}
          handleEditAccountDetails={handleEditAccountDetails}
          handleResetEditData={handleResetEditData}
          autoUniqueNumberGenerationData={  autoUniqueNumberGenerationData}
          dispatchResetAutoUniqueNumberGenerationData={dispatchResetAutoUniqueNumberGenerationData}

        />
      )}
         {showConfirmationModal && confirmationModalData?.ledger_id && (
        <ConfirmationModal
          toggle={() => {
            handleConfirmationModal();
          }}
          isOpen={showConfirmationModal}
          title={`${
            !confirmationModalData?.is_disabled ? "Disable" : "Enable"
          } Account Manager ?`}
          message={`Are you sure you want to ${
            !confirmationModalData?.is_disabled ? `Disable ` : `Enable`
          }?`}
          confirmButtonText={
            confirmationModalData?.is_disabled ? "Enable" : "Disable"
          }
          onPressConfirm={() => {
            handleChangeCustomerSupplierStatus(confirmationModalData);
            handleConfirmationModal();
          }}
        />
      )}
      {fetching && (offset === 0 || showAddAccountModal) && <Loader />}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  success: state.clientSettings.success,
  fetching: state.clientSettings.fetching,
  error: state.clientSettings.error,
  statusCode: state.clientSettings.statusCode,
  allLedgersList: state.clientSettings.allLedgersList,
  message:state.clientSettings.message,
  allLedgersListTotal: state.clientSettings.allLedgersListTotal,
  autoUniqueNumberGenerationData: state.clientSettings.autoUniqueNumberGenerationData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetLedgerMessage: () => dispatch(resetLedgerMessage()),
  dispatchResetClientSettingsSuccess: () =>
    dispatch(resetClientSettingsSuccess()),
  dispatchResetClientSettingsError: () => dispatch(resetClientSettingsError()),
  dispatchAddLedgerAction: (data: AddLedgerPayloadType) =>
    dispatch(addLedgerAction(data)),
  dispatchUpdateLedgerAction: (data: UpdateLedgerPayloadType) =>
    dispatch(updateLedgerAction(data)),
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllLedgersListAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetAllLedgersList: () => dispatch(resetAllLedgersList()),
  dispatchResetAllLedgersListTotal: () => dispatch(resetAllLedgersListTotal()),
  dispatchResetSingleTypeLedgersList: () =>
    dispatch(resetSingleTypeLedgersList()),
  dispatchChangeCustomerSupplierStatusAction: (data: ChangeStatusCustomerSupplierPayloadType) =>
    dispatch(changeCustomerSupplierStatusAction(data)),
  dispatchResetMessage:()=> dispatch(resetMessage()),
  dispatchGetAutoUniqueNumberCheckAction: (data: GetAutoUniqueNumberPayloadType) => dispatch(getAutoUniqueNumberGenerationAction(data)),
  dispatchResetAutoUniqueNumberGenerationData: () =>
    dispatch(resetAutoUniqueNumberGenerationData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountsManager);
